import React from 'react'
import { usePatients } from './hooks/usePatients'
import { Link, useNavigate } from 'react-router-dom'

const Patients = () => {
    const patients = usePatients()
    const navigate = useNavigate()
    console.log('Patients: ', patients)
  return (
    <div>
        <h1 style={{display: 'flex', justifyContent: 'space-between'}}>Patients <button onClick={() => navigate('/patient')}>Add</button></h1>
        <table>
            <thead>
                <tr>
                    <th>Name</th>
                    <th>Age</th>
                    <th>Previous Visited</th>
                    <th>Phone</th>
                    <th>Visited Purpose</th>
                </tr>
            </thead>
            <tbody>
                {patients?.map( o => 
                <tr key={o._id}>
                    <td>{o.name}</td>
                    <td>{o.age}</td>
                    <td>{o.phone}</td>
                    <td>{o.visited_purpose}</td>
                    <td>{o.given_medicine}</td>
                    <td style={{display: 'flex', justifyContent: 'space-around'}}>
                        <Link to={`/patient/${o._id}`}>View</Link>
                        {/* <Link to={`/patient-edit/${o._id}`}>Edit</Link>
                        <button>Delete</button> */}
                    </td>
                </tr>
                )}
            </tbody>
        </table>
    </div>
  )
}

export default Patients

/* 

age
: 
45
given_medicine
: 
"Medicine1"
name
: 
"Ravi"
phone
: 
9858563392
previous_visited
: 
true
visited_purpose
: 


*/